module.exports = function () {
    $(document).ready(function () {

        var helper = require('../../helper');

        var index = $('#vip_provided_rule_fields').data('index');

        $(":radio[value=2]").on('click', function (e) {
            var ruleInputs = '<div class="mt-30"><div class="form-group pull-right rule"><div class="col-sm-3"><div class="form-group">' +
                '<label for="vip_amount_rule['+ index +'][months]" class="control-label col-sm-4">For (months)</label><div class="col-sm-7">' +
                '<input class="form-control" name="vip_amount_rule['+ index +'][months]" type="text" id="vip_amount_rule['+ index +'][months]">' +
                '<small class="text-muted">Leave empty if amount is the same for all months</small>' +
                '</div></div></div>' +
                '<div class="col-sm-3"><div class="form-group">' +
                '<label for="vip_amount_rule['+ index +'][amount]" class="control-label col-sm-4">Amount</label><div class="col-sm-7">' +
                '<input class="form-control" required="required" name="vip_amount_rule['+ index +'][amount]" type="text" id="vip_amount_rule['+ index +'][amount]"></div></div></div>' +
                '<div class="col-sm-1 pull-left">' +
                '<button class="btn btn-add" type="button" style="border:none;background:transparent;color:green;font-weight: bold;">Add</button></div>' +
                '<div class="col-sm-1 pull-left">' +
                '<button class="btn btn-remove" type="button" style="border:none;background:transparent;color:red;font-weight: bold;">Delete</button></div>' +
                '</div></div>';

            if (!$('div.rule').length) {
                $("#vip_provided_rule_fields").append(ruleInputs);
                ++index;
            }
        })

        $(":radio[value=0], :radio[value=1]").on('click', function (e) {
            $("#vip_provided_rule_fields").empty();
            $('div.rule').remove();
        });

        $('body').on('click', "#vip_provided_set_rule, .btn-add", (function() {
            
            var ruleInputs = '<div class="form-group pull-right rule"><div class="col-sm-3"><div class="form-group">' +
                '<label for="vip_amount_rule['+ index +'][months]" class="control-label col-sm-4">For (months)</label><div class="col-sm-7">' +
                '<input class="form-control" name="vip_amount_rule['+ index +'][months]" type="text" id="vip_amount_rule['+ index +'][months]">' +
                '<small class="text-muted">Leave empty if amount is the same for all months</small>' +
                '</div></div></div>' +
                '<div class="col-sm-3"><div class="form-group">' +
                '<label for="vip_amount_rule['+ index +'][amount]" class="control-label col-sm-4">Amount</label><div class="col-sm-7">' +
                '<input class="form-control" required="required" name="vip_amount_rule['+ index +'][amount]" type="text" id="vip_amount_rule['+ index +'][amount]"></div></div></div>' +
                '<div class="col-sm-1 pull-left">' +
                '<button class="btn btn-add" type="button" style="border:none;background:transparent;color:green;font-weight: bold;">Add</button></div>' +
                '<div class="col-sm-1 pull-left">' +
                '<button class="btn btn-remove" type="button" style="border:none;background:transparent;color:red;font-weight: bold;">Delete</button></div>' +
                '</div>';

                if ($('div.rule').length) {
                    $('div.rule:last').after(ruleInputs);
                } else {
                    $("#vip_provided_rule_fields").append(ruleInputs);
                }
                ++index;

            return false;
        }));

        $(document).on('click', '.btn-remove', function (e) {
            $(this).parents('.rule:first').remove();
            e.preventDefault();
            return false;
        });
    });
}();
